





























import { Component, Vue, Prop } from 'vue-property-decorator';
import { GQL_getWorkRelationPaycheckLineTemplates_workRelation } from '@/queries/__generated__/getWorkRelationPaycheckLineTemplates';

@Component({
  components: {},
})

export default class EmployeeInformationForm extends Vue {
  @Prop({ type: Object, required: true }) private workRelation!: GQL_getWorkRelationPaycheckLineTemplates_workRelation;
}
